import { FC } from 'react';
import { Popover } from 'antd';

interface ContentProps {
  title: string;
  text: string;
}
// Android下载
const downAndroid = (
  <div style={{width:'15rem',maxWidth:'100%',cursor:'pointer'}}>
    <img src="/image/download-android.png"   />
  </div>
);
// ios下载
const downIos = (
  <div style={{width:'15rem',maxWidth:'100%',cursor:'pointer'}}>
    <img src="/image/download-ios.png"   />
  </div>
);
// 小程序下载
const downWechart = (
  <div style={{width:'15rem',maxWidth:'100%',cursor:'pointer'}}>
    <img src="/image/download-wechart.png"   />
  </div>
);
// 鸿蒙下载
const downHarmony = (
  <div style={{width:'15rem',maxWidth:'100%',cursor:'pointer'}}>
    <img src="/image/download-ohos.png"   />
  </div>
);



export const Content: FC<ContentProps> = ({ title, text }) => {
  return (
    <div className="component-content">
      <div className="title">{title}</div>
      <div className="subtitle">{text}</div>

      <div className="wrap">
        <div className="scan">
          <img src="/image/scan.png" alt="" />
        </div>

        <div className="info">
          <div className="name">获取桃高乐应用程序</div>

          <div className="tip">
            扫描二维码可以获取应用程序或者从应用商店下载
            {/* 更多联系方式： */}
            {/* <a href="mailto:service@taogao88.com" rel="noopener noreferrer">
              service@taogao88.com
            </a> */}
          </div>

          {/* <div className="policy">
            <a href="/privacypolicy" rel="noopener noreferrer">
              隐私政策
            </a>
          </div> */}

          <div className="icons">
            <Popover content={downAndroid}  >
              <div className="icon">
                <img src="/image/android.png" alt="Android 下载" />
              </div>
            </Popover>

            <div className="line" />
            <Popover content={downIos}  >
              <div className="icon">
                <img src="/image/ios.png" alt="iOS 下载" />
              </div>
            </Popover>
            <div className="line" />
            <Popover content={downHarmony}  >
              <div className="icon">
                <img src="/image/ohos.png" alt="鸿蒙" />
              </div>
            </Popover>

            <div className="line" />
            <Popover content={downWechart}  >
              <div className="icon">
                <img src="/image/wechart.png" alt="微信小程序" />
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};
